import cn from 'classnames';
import { Text } from '@/shared/ui/core';
import { HTMLAttributes } from 'react';
import styles from './card.module.scss';


export function CardDescription ({ className, ...props }: HTMLAttributes<HTMLParagraphElement>) {
    return (
        <Text
            size='lg'
            tone='secondary'
            as='p'
            className={ cn(styles.description, className ) }
            data-template="card-description"
            lineHeight={ 1.2 }
            { ...props }
        />
    );
}
